import React, { createContext, useContext, useState, useCallback } from 'react';
import { getUserDetails, setUserDetails, clearUserDetails } from '../../utils/storage';

const AuthContext = createContext(null);

const EMPTY_USER = {
  jwttoken: null,
  accountInfo: {
    firstname: null,
    surname: null,
    username: null,
    email: null,
    dob: null,
    telephone: null,
    settings: { pushnotifications: null },
  },
  myJobs: {},
  myQuotes: {},
  messages: {},
  userType: null,
  short_id: null,
};

export function AuthProvider({ children }) {
  const [userDetails, setUserState] = useState(() => {
    const saved = getUserDetails();
    return saved ?? EMPTY_USER;
  });

  const isLoggedIn =
    userDetails.jwttoken != null &&
    userDetails.accountInfo?.username != null;

  const updateUserDetails = useCallback((nextUser) => {
    setUserDetails(nextUser);
    setUserState(nextUser);
  }, []);

  const logout = useCallback(() => {
    clearUserDetails();
    setUserState(EMPTY_USER);
  }, []);

  return (
    <AuthContext.Provider value={{ userDetails, isLoggedIn, updateUserDetails, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within an AuthProvider');
  return ctx;
};

export default AuthContext;
